import { render, staticRenderFns } from "./bjFamousDoctor.vue?vue&type=template&id=99b43112&scoped=true"
import script from "./bjFamousDoctor.vue?vue&type=script&lang=js"
export * from "./bjFamousDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b43112",
  null
  
)

export default component.exports